import HolidayService from '@/services/retailer/HolidayService.js'

import { errorMessage } from '@/utilities/helpers.js'

import { HOLIDAY_ERROR_MESSAGES } from '@/constants/errorMessages'

export const namespaced = true

export const state = {
  holidays: []
}

export const mutations = {
  SET_HOLIDAYS(state, holidays) {
    state.holidays = holidays.data
  },
  SET_VALUE(state, parameters) {
    state[parameters.type] = parameters.value
  }
}

export const actions = {
  getHolidays({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      HolidayService.getHolidays()
        .then(response => {
          commit('SET_HOLIDAYS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notifications = {
            type: 'danger',
            message: HOLIDAY_ERROR_MESSAGES.getHolidaysError + errorMessage(err)
          }
          dispatch('notification/add', notifications, {
            root: true
          })
          reject(err)
        })
    })
  }
}
